<ansyn-slider-checkbox [checked]="currentCase?.autoSave"
					   (checkedChange)="onChange($event.target.checked)"></ansyn-slider-checkbox>
